import { render, staticRenderFns } from "./PredefinedTourSearchbar.vue?vue&type=template&id=0c2f80c0&scoped=true"
import script from "./PredefinedTourSearchbar.vue?vue&type=script&lang=js"
export * from "./PredefinedTourSearchbar.vue?vue&type=script&lang=js"
import style0 from "./PredefinedTourSearchbar.vue?vue&type=style&index=0&id=0c2f80c0&prod&scoped=true&lang=css"
import style1 from "./PredefinedTourSearchbar.vue?vue&type=style&index=1&id=0c2f80c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f80c0",
  null
  
)

export default component.exports